var _style, _rect, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJournal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 156,
    className: "st0",
    width: 104,
    height: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 38.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 146.0059 -59.0902)",
    className: "st0",
    width: 17.9,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.2,
    y: 56.4,
    transform: "matrix(-0.8296 0.5584 -0.5584 -0.8296 307.1353 29.0661)",
    className: "st0",
    width: 17.9,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 56.4,
    transform: "matrix(0.8296 0.5584 -0.5584 0.8296 43.8267 -20.7855)",
    className: "st0",
    width: 17.9,
    height: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.5,62.1L102.5,62.1c-26.1,0-47.3,21.2-47.3,47.3v32.5c0,3.4,2.8,6.2,6.2,6.2h82.3c3.4,0,6.2-2.8,6.2-6.2 v-32.5C149.9,83.3,128.7,62.1,102.5,62.1z M139.9,138.1H86.7V110h-10v28.2H65.2v-28.7c0-20.6,16.8-37.3,37.3-37.3 c20.6,0,37.3,16.8,37.3,37.3V138.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.55079563.svg";
export { ForwardRef as ReactComponent };